import { Logger } from '@wolfdanepug/common-react'
import {
	ADD_TO_CART,
	CLEAR_CART,
	REMOVE_FROM_CART,
	SET_CHANNEL,
	SET_COUPON,
	SET_DISCOUNT_CODE,
	SET_REFERRAL,
	UPDATE_QUANTITY
} from './actions'
import initialState from './state'

const addItem = (state: any, { id, quantity }: any) => {
	Logger.log('Adding item:', id, quantity)
	const newState = { ...state }
	const idx = newState.items.findIndex((item: any) => item.id === id)
	if (idx > -1) {
		newState.items[idx].quantity += quantity
	} else {
		newState.items.push({ id, quantity })
	}

	return newState
}

const updateQuantity = (state: any, { id, quantity }: any) => {
	const newState = { ...state }
	const idx = newState.items.findIndex((item: any) => item.id === id)
	if (idx > -1) {
		newState.items[idx].quantity = quantity
	} else {
		newState.items.push({ id, quantity })
	}

	return newState
}

const removeItem = (state: any, id: any) => {
	return {
		...state,
		items: state.items.filter((item: any) => item.id !== id)
	}
}

const clearCart = () => ({
	...initialState
})

export default function reducer(state: any, { type, payload }: any) {
	switch (type) {
		case ADD_TO_CART:
			return addItem(state, payload)
		case UPDATE_QUANTITY:
			return updateQuantity(state, payload)
		case REMOVE_FROM_CART:
			return removeItem(state, payload)
		case CLEAR_CART:
			return clearCart()
		case SET_DISCOUNT_CODE:
			return { ...state, discountCode: payload }
		case SET_COUPON:
			return { ...state, coupon: payload }
		case SET_REFERRAL:
			return { ...state, referral: payload }
		case SET_CHANNEL:
			return { ...state, channel: payload }
		default:
			return state
	}
}
